import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Practice } from '../interfaces/practice';
import { PracticeInscription } from '../interfaces/practiceinscription';

export interface PracticeInscriptionMutationResponse {
  code?: string;
  msg: string;
  data?: PracticeInscription;
  practice?: Practice;
}

@Injectable({
  providedIn: 'root'
})
export class PracticeInscriptionService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/practiceinscriptions/'
  }
  getListPracticeInscriptions(): Observable<PracticeInscription[]> {
      return this.http.get<PracticeInscription[]>(`${this.myAppUrl}${this.myApiUrl}`);
      
     }
   
     deletePracticeInscription(id: number): Observable<void> {
      console.log("id en service: "+id);
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     savePracticeInscription(areacentro: PracticeInscription): Observable<PracticeInscriptionMutationResponse> {
       return this.http.post<PracticeInscriptionMutationResponse>(`${this.myAppUrl}${this.myApiUrl}`,areacentro)
     }
   
     getPracticeInscription(id: number): Observable<PracticeInscription> {
       return this.http.get<PracticeInscription>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updatePracticeInscription(id: number, areacentro: PracticeInscription): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, areacentro);
     }
     updatePracticeInscriptionState(id: number, state: { state: number }): Observable<void> {
      return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}/state`, state);
    }
    /*getPracticeInscriptionsByStudentId(studentId: number): Observable<PracticeInscription[]> {
     
     console.log("El service recibe: "+studentId);
      return this.http.get<PracticeInscription[]>(`${this.myAppUrl}${this.myApiUrl}${studentId}`);
    }*/
    getPracticeInscriptionsByStudentId(studentId: number): Observable<PracticeInscription[]> {
      console.log("El service recibe: "+studentId);
      return this.http.get<PracticeInscription[]>(`${this.myAppUrl}${this.myApiUrl}student/${studentId}`);
    }
    // Nuevo método para obtener inscripciones de prácticas con el refactor
    getPracticeInscriptionsByStudentIdV2(studentId: number): Observable<PracticeInscription[]> {
      return this.http.get<PracticeInscription[]>(`${this.myAppUrl}${this.myApiUrl}student/v2/${studentId}`);
    }

    deleteAllPracticeInscriptions(): Observable<void> {
      return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}deleteAll`);
    }

    // services/practiceinscription.service.ts
    getPracticeInscriptionsByPracticeId(practiceId: number): Observable<PracticeInscription[]> {
      return this.http.get<PracticeInscription[]>(`${this.myAppUrl}${this.myApiUrl}practice/${practiceId}`);
    }
    
    }
   
